import { z } from "zod";
export const CreateAuthorizationCodeResponseSchema = z.object({
    url: z.string().url(),
    authorizationCode: z.string(),
});
export const GetPersonalAccessTokenRequestSchema = z.object({
    authorizationCode: z.string(),
});
export const GetPersonalAccessTokenResponseSchema = z.object({
    token: z
        .object({
        token: z.string(),
        obfuscatedToken: z.string(),
    })
        .nullable(),
});
//# sourceMappingURL=tokens.js.map